import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useState } from "react";
import { ContentPartFilter } from "../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../components/page-header";
import { EntReservoir } from "../../../models/reservoir";
import { EntReservoirFilter } from "../../../models/filters/reservoirFilter";
import { useReservoirs } from "./useReservoirs";
import { FilterReservoirs } from "./FilterReservoirs";
import { AddReservoirsModal } from "./AddReservoirsModal";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetReservoirListQuery } from "../../../redux/api/reservoir/reservoirApi";

enum FormField {
  name,
  yearOfConstruction,
  minDesignCapacity,
  maxDesignCapacity,
  deleted,
}

export const Reservoirs = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedReservoir, setSelectedReservoir] = useState<EntReservoir>(new EntReservoir());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetReservoirListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntReservoir, EntReservoirFilter>({
	initialFilter: new EntReservoirFilter(),
	query: getArchiveFolders
  });

  const { onAddReservoir, onEditReservoir, onDeleteReservoir } = useReservoirs(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);
  const openAddModal = (item: EntReservoir) => {
	setSelectedReservoir(item);
	setShowModal(true);
  }
  const setEntityFromFields = (): EntReservoirFilter => {
	let filt: EntReservoirFilter = _.clone(filter);
	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.yearOfConstruction = form.getFieldValue(FormField.yearOfConstruction) ?? null;
	filt.minDesignCapacity = form.getFieldValue(FormField.minDesignCapacity) ?? null;
	filt.maxDesignCapacity = form.getFieldValue(FormField.maxDesignCapacity) ?? null;
	filt.deleted = form.getFieldValue(FormField.deleted) ?? false;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	  { name: FormField.yearOfConstruction, value: null },
	  { name: FormField.minDesignCapacity, value: null },
	  { name: FormField.maxDesignCapacity, value: null },
	  { name: FormField.deleted, value: false },
	]);
  }
  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }
  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th>{ t('reservoir.year_construction') }</th>
		  <th>{ t('reservoir.design_capacity') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.nameKy } </td>
			<td>{ item.nameRu } </td>
			<td>{ item.yearOfConstruction } </td>
			<td>{ item.designCapacity } </td>

			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteReservoir(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.register_of_reservoirs') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary">{ t('general.records_found') } { totalItems }</Typography.Text> }/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntReservoir)
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterReservoirs onSearch={ searchHandleClick }
								   onReset={ () => {
									 clearFields();
									 searchHandleClick()
								   } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }

	  />

	  <AddReservoirsModal
		reservoir={ selectedReservoir }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedReservoir.id !== 0 ? onEditReservoir : onAddReservoir }
	  />
	  { contextHolder }
	</>
  )
}
